"use client";

import { useRef, useState } from "react";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

export function ZoomInOnScroll(props) {
  const [styles, setStyles] = useState({
    opacity: 0,
    translateY: 250,
    scale: 0.8,
    borderRadius: "0.5rem",
  });
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    setStyles({
      opacity: latest * 2,
      translateY: 250 - latest * 250,
      scale: 0.8 + latest * 0.2,
      borderRadius: latest === 1 ? "0" : "0.5rem",
    });
  });

  return (
    <motion.div {...props} style={styles} ref={ref}>
      {props.children}
    </motion.div>
  );
}
